/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-19 16:08:55
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-20 20:10:17
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/Query1/Sort/index.tsx
 */
import DropDown from '@/src/components/Antd/DropDown/DropDown';
import {
  CaretDownOutlined,
  CaretUpOutlined,
  CheckOutlined,
} from '@ant-design/icons';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './Query.less';

const Sort = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { sortList = [], onChange, data: currentSelected = {} } = props;
  const { value, label } = currentSelected;
  const _sorts = sortList.find((i) => i.value === value);
  const _label = _sorts ? i18nGet(_sorts, 'label') : null;

  const handleOnSort = (list) => {
    if (onChange) onChange(list);
  };
  const overlaySort = (
    <div className={css.queryOverlay}>
      {sortList.map((list) => (
        <div
          className={css.overlaylist}
          onClick={handleOnSort.bind(this, list)}
          key={list.value}>
          <span className={css.overlaylistIcon}>
            {value === list.value && <CheckOutlined />}
          </span>
          {list.label}
        </div>
      ))}
    </div>
  );
  return sortList.length ? (
    <div className={css.container}>
      <span className={css.sortByText}>{getI18n('general.sort.sortby')}</span>
      <DropDown
        className={`${css.dropDown} ${css.sortDropDown}`}
        overlay={overlaySort}
        trigger={['click']}>
        <div className={css.dropDownNameContainer}>
          <div className={css.dropDownName}>
            {label || _label || getI18n('general.sort')}
          </div>
          <span className={css.dropDownSpan}>
            <CaretUpOutlined />
            <CaretDownOutlined />
          </span>
        </div>
      </DropDown>
    </div>
  ) : (
    <div></div>
  );
};
export default Sort;
